import React from "react";
import propTypes from "prop-types";
import {  Distribution } from "../../../../logic/api";
import styles from "./styles";

 
import ListViewItemCard from "../../../cards/ListItemCard/ListItemCard";

import flex from "../../../../styles/flex";
import { IconButton } from "@mui/material";
import { FiEdit, FiUser } from "react-icons/fi";

const DistributionListItem: React.FunctionComponent<{
    item: Distribution,
    onClick?: () => void,
    onEdit?: () => void,
    
}> = (props) => {
    const border = styles.border
 
 
    return (
        <div style={{ ...styles.listItem, ...border }} onClick={() => {
            if (props.onClick != null) {
                props.onClick();
            }
        }} >
            <div style={styles.listItemFlex}>

                <ListViewItemCard
                    icon={<FiUser style={styles.icon} />}
                    text={props.item.name}


                />
                <ListViewItemCard

                    text={props.item.email}
                    subSubText={props.item.mobile}

                />
                {
                    props.onEdit != null && (
                        <div style={flex.flexAuto} onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();

                            if (props.onEdit != null) {
                                props.onEdit();
                            }

                            return false;
                        }}>
                            <IconButton>
                                <FiEdit />
                            </IconButton>
                        </div>
                    )
                }      


            </div>
        </div>
    );
}


DistributionListItem.propTypes = {
    item: propTypes.any.isRequired,
    onClick: propTypes.func,
    onEdit: propTypes.func,
};


export default DistributionListItem;